import { Component, OnInit } from '@angular/core';
import { DataStoreService } from "../../shared/services/api/data-store.service";
import { ActivatedRoute } from "@angular/router";
import { Appointment } from "../../shared/models/appointment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import { Report } from "../../shared/models/report";
import * as moment from "moment";
import { Location } from "@angular/common";
import { LoadingStateService } from "../../shared/services/loading-state.service";

@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.css']
})
export class ReportDetailComponent implements OnInit {


  public editMode = false;
  public form: FormGroup = null;

  constructor(private route: ActivatedRoute,
              private dataStore: DataStoreService,
              private notificationService: NotificationsService,
              private location: Location,
              private loadingState: LoadingStateService,
              private fb: FormBuilder) {
  }

  public report: Report;

  ngOnInit() {
    this.route.data.subscribe((data: {report?: Report, appointment?: Appointment}) => {
      if (data.report == null) {
        this.report = data.appointment.report
      } else {
        this.report = data.report;
      }
      if (this.report == null && data.appointment != null ) {
        this.editMode = true;
        this.report = this.dataStore.createRecord(Report);
        this.report.appointment = data.appointment;
      }
      this.createForm();
    }, (error) => console.error(error));
  }

  private createForm() {
    let reminder = this.report.reminder ? moment(this.report.reminder).format("YYYY-MM-DDThh:mm") : null;
    this.form = this.fb.group({
      "reminder": [reminder],
      "important": [this.report.important],
      "todo": [this.report.todo],
      "reminderEnabled": [this.report.reminder != null],
      "description": [this.report.description, Validators.required],
      "subject": [this.report.subject, Validators.required],
      "location": [this.report.location || ""]
    });

    this.form.controls["reminderEnabled"].valueChanges.subscribe(enabled => {
        const reminderValue = this.form.controls["reminder"].value;
        if (enabled && reminderValue == null) {
          this.form.controls["reminder"].patchValue(moment().add(1, "weeks").hour(10).minute(0).format("YYYY-MM-DDThh:mm"));
        }
        if (!enabled) {
          this.form.controls["reminder"].patchValue(null)
        }
      }
    )
  }

  submit() {
    this.form.updateValueAndValidity();
    if (this.form.valid && this.form.dirty) {
      if (!this.form.value.reminderEnabled) {
        delete this.form.value.reminder;
      } else {
        this.form.value.reminder = moment(this.form.value.reminder).format('YYYY-MM-DD HH:mm:ss')
      }
      Object.assign(this.report, this.form.value);
      this.loadingState.setLoading(true);
      this.report.save().subscribe(report => {
        this.notificationService.success("Erfolg", "Bericht wurde gespeichert");
        this.editMode = false;
        this.loadingState.setLoading(false);
      }, (error) => {
        this.notificationService.error("Speichern fehlgeschlagen",
          "Bericht konnte nicht gespeichert werden.")
      });
    }
  }

  private enableEditMode() {
    window.setTimeout(() => this.editMode = true, 20);
  }

  private markAsDone() {
    if (this.report.reminder != null) {
      this.report.reminder = null;
      this.report.save().subscribe(report => {
        this.notificationService.success("Abgeschlossen", "Bericht wurde als fertig markiert")
        this.form.controls["reminder"].patchValue(null);
        this.form.controls["reminderEnabled"].patchValue(false);
      })
    }
  }

  private deleteReport() {
    this.dataStore.deleteRecord(Report, this.report.id).subscribe(result => {
      this.notificationService.success("Gelöscht", "Bericht wurde gelöscht");
      this.location.back();

    });
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/report/report-detail/report-detail.component.ts